import { gql } from "@apollo/client";

export const MENU_ITEMS_QUERY = gql`
  query menuItems {
    menuItems {
      id
      caption
      route
      icon
      code
    }
  }
`;
